module.exports = __webpack_public_path__ + "static/media/women.66967c99.webp";